import React from 'react';
import { CProgress } from '@coreui/react';

const StationTempWidget = ({ stationTemp }) => (
  <div>
    <div className="mb-2">Station Temp</div>
    <strong>{stationTemp} Celsius (40%)</strong>
    <CProgress className="CProgress-xs mt-2" color="success" value={40} />
  </div>
);

export default StationTempWidget;


